import { useState, useEffect } from 'react';
import { SellerSignupCompletePage } from './auth/SellerSignupCompletePage';
import { DesktopSellerSignupCompletePage } from './desktop/DesktopSellerSignupCompletePage';

export function ResponsiveSellerSignupCompletePage() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const checkScreenSize = () => {
      const newIsMobile = window.innerWidth < 1024;
      setIsMobile(newIsMobile);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return isMobile ? <SellerSignupCompletePage /> : <DesktopSellerSignupCompletePage />;
}